import { selectLimits } from "../state/selectors/limits";
import { api } from '../constants/limits_constants.js';
import { httpClient } from "./httpClient";
import log from "./logger/log";
import { updateLimits } from "../state/ducks/limits";
import { dispatch } from "../state/store";

const getLimits = async (filter, token) => {
    let canceled;
    token = token ? token : {};
    token.cancel = () => {
        canceled = true;
    }

    const url = api.GET_ALL_LIMITS;

    let postData = {
        pageNumber: filter.pagesFilter.currentPage,
        modelFilter: filter.modelFilter,
        sortFilter: filter.sortFilter
    }

    try {
        if(canceled) {
            throw new Error("canceled");
        };

        const data = await httpClient.post(url, postData);
        const limits = {
            items: data.items,
            filter: {
                pagesFilter: { currentPage: data.currentPage, pageCount: data.pagesCount, maxItemsOnPage: data.maxItemsOnPage },
                modelFilter: filter.modelFilter,
                sortFilter: filter.sortFilter
            }
        }

        if(canceled) {
            throw new Error("canceled");
        };

        dispatch(updateLimits(limits));
        return limits;
    }
    catch (error) {
        if(error.message === 'canceled') {
            log.debug(error.message);
            return null;
        }
        log.error(JSON.stringify(error));
        throw error;
    }
}

const getReport = async (filter) => {
    const url = api.GET_LIMITS_REPORT;

    // const filter = selectOperationsFilter()(getState());
    const postData = {
        pageNumber: filter.pagesFilter.currentPage,
        modelFilter: filter.modelFilter,
        sortFilter: {}
    }

    try {
        const response = await httpClient.getReport("POST", url, postData);
        return response;
    }
    catch (error) {
        log.error(JSON.stringify(error));
    }
}

const limitService = {
    getLimits,
    getReport
}

export default limitService;